/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Phone } from '../models/Phone';
import type { UpdateAssignedPhoneParams } from '../models/UpdateAssignedPhoneParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PhonesService {
    /**
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns Phone Ok
     * @throws ApiError
     */
    public static getPhones(
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<Array<Phone>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/phones',
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @returns Phone Ok
     * @throws ApiError
     */
    public static getAvailablePhones(): CancelablePromise<Array<Phone>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/phones/available',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @returns Phone Ok
     * @throws ApiError
     */
    public static getAssignedPhone(): CancelablePromise<Phone> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/phones/available/assigned',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateAssignedPhone(
        requestBody: UpdateAssignedPhoneParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/phones/available/assigned',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
}
